import { useRef, useState } from "react";
import { webUrlNode } from "../../../../constants/appInfo";

export default function PannableCanvas({ children }) {

  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [start, setStart] = useState({ x: 0, y: 0 });
 const wrapperRef = useRef(null);


  function onMouseDown(e) {

    // only when clicking the empty background

    setDragging(true);

    setStart({
      x: e.clientX - offset.x,
      y: e.clientY - offset.y
    });
  }

  function onMouseMove(e) {
    if (!dragging) return;

    setOffset({
      x: e.clientX - start.x,
      y: e.clientY - start.y
    });
  }

  function stop() {
    setDragging(false);
  }
function onWheel(e) { // block browser back/forward gesture
  if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
    e.preventDefault();
  }
    setOffset(prev => ({
      x: prev.x - e.deltaX,
      y: prev.y - e.deltaY
    }));
  }

  return (
    <div
    ref={wrapperRef}
      onWheel={onWheel}
     
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={stop}
      onMouseLeave={stop}
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",overscrollBehaviorX: "none",   // ✅ important
    overscrollBehaviorY: "none",   // optional
        cursor: dragging ? "grabbing" : "grab",
        background: "#fafafa"
      }}
    >
      <div
        style={{
          transform: `translate(${offset.x}px, ${offset.y}px)`,
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%"
        }}
      >
        {children}
      </div>
    </div>
  );
}
